export default "__VITE_ASSET__01b6bafb__"